import React from 'react';
import { Tooltip } from 'antd';
import intl from 'react-intl-universal';

import { format2TimeStamp } from '@/utils/date';
import CustomCalendar from '@/components/RoomFutureCalendar';

import styles from './index.module.scss';

const Index = (props) => {
  const { showCalendar, children, roomId, roomNo, businessDate } = props;

  if (!showCalendar) return children;

  return (
    <Tooltip
      title={() => (
        <div>
          <div className={styles.triggerRoomInfo}>
            <span className={styles.labelInfo}>{intl.get('app_constants_room_no')}</span>
            <span>{roomNo}</span>
          </div>
          <CustomCalendar roomId={roomId} businessDate={format2TimeStamp(businessDate)} />
        </div>
      )}
      overlayClassName={styles.calendarPopup}
      placement="top"
      mouseEnterDelay={0.5}
      destroyTooltipOnHide
    >
      {children}
    </Tooltip>
  );
};
export default Index;
